<template>
  <div
    class="audio-item-skeleton-box"
    :class="{
      'audio-item-skeleton-box-mobile': createRenderType == 'mobile',
      'audio-item-skeleton-box-pc': createRenderType == 'pc',
    }"
  >
    <div class="audio-item-skeleton-cover-box">
      <div class="audio-item-skeleton-cover-box-mask flex-center">
        <i class="rotate-loading"> </i>
      </div>
    </div>
    <div class="audio-item-skeleton-content-box flex1 width-0">
      <el-skeleton :rows="2" animated />
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
} from "vue"

import { useRouter, useRoute } from "vue-router"

import useCreateLayoutStore from "@/store/create/createLayoutStore.js"

const createLayoutStore = useCreateLayoutStore()
const { createRenderType } = storeToRefs(createLayoutStore)

const Router = (getCurrentInstance() || window?.$getVueCurrentInstance?.())
  .appContext?.config?.globalProperties?.$router
const route = useRoute()

const props = defineProps({})
const emits = defineEmits([])
const renderData = reactive({})

onMounted(() => {})
</script>
<style lang="scss">
@keyframes el-skeleton-loading {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}
.audio-item-skeleton-box {
  display: flex;
  align-items: center;
  padding: 12px 18px 12px 22px;
  align-items: center;
  .audio-item-skeleton-cover-box {
    width: 72px;
    height: 72px;
    border-radius: 16px;
    background: url("@/assets/img/default-cover-3x.png");
    background-size: 100% 100%;
    .audio-item-skeleton-cover-box-mask {
      width: 100%;
      height: 100%;
    }
    .rotate-loading {
      width: 24px;
      height: 24px;
      background: url("@/assets/img/loading-mini-white-3x.png");
      background-size: 100% 100%;
      opacity: 0.5;
    }
  }
  .audio-item-skeleton-content-box {
    margin-left: 16px;
    .el-skeleton {
      .el-skeleton__item {
        height: 14px;
        margin-top: 2px;
        background: linear-gradient(
          90deg,
          rgba(255, 255, 255, 0.1) 25%,
          rgba(255, 255, 255, 0.2) 37%,
          rgba(255, 255, 255, 0.1) 63%
        );
        background-size: 400% 100%;
        animation: el-skeleton-loading 1.4s ease infinite;
      }
    }
  }
  &.audio-item-skeleton-box-mobile {
    padding: 12px 16px 12px 20px;
    .audio-item-skeleton-cover-box {
      width: 68px;
      height: 68px;
    }
    .audio-item-skeleton-content-box {
      margin-left: 12px;
    }
  }
}
</style>
